import React, { useState } from "react";

export default function ManageBlogs() {
  const [blogs, setBlogs] = useState([
    {
      id: 1,
      title: "How AI is Transforming Web Development",
      author: "Omar Arshad",
      date: "2025-07-15",
    },
    {
      id: 2,
      title: "React vs Next.js – Which One Should You Choose?",
      author: "Hina Malik",
      date: "2025-06-20",
    },
  ]);

  const [showForm, setShowForm] = useState(false);
  const [formData, setFormData] = useState({
    id: null,
    title: "",
    author: "",
    date: "",
    content: "",
  });

  // ✅ Open Form for Add or Edit
  const openForm = (blog = null) => {
    if (blog) {
      setFormData(blog);
    } else {
      setFormData({ id: null, title: "", author: "", date: "", content: "" });
    }
    setShowForm(true);
  };

  // ✅ Save Blog (Add or Update)
  const saveBlog = () => {
    if (formData.id) {
      // Update existing
      setBlogs(blogs.map((b) => (b.id === formData.id ? formData : b)));
    } else {
      // Add new
      setBlogs([
        ...blogs,
        { ...formData, id: blogs.length + 1, date: new Date().toISOString().slice(0, 10) },
      ]);
    }
    setShowForm(false);
  };

  // ✅ Delete Blog
  const deleteBlog = (id) => {
    if (window.confirm("Are you sure you want to delete this blog?")) {
      setBlogs(blogs.filter((b) => b.id !== id));
    }
  };

  return (
    <div>
      <div className="flex justify-between items-center mb-6">
        <h2 className="text-2xl font-bold">📝 Manage Blogs</h2>
        <button
          onClick={() => openForm()}
          className="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700"
        >
          ➕ Add Blog
        </button>
      </div>

      {/* ✅ BLOGS TABLE */}
      <div className="bg-white shadow rounded-lg overflow-hidden">
        <table className="w-full">
          <thead className="bg-gray-100">
            <tr>
              <th className="px-4 py-2 text-left">Title</th>
              <th className="px-4 py-2">Author</th>
              <th className="px-4 py-2">Date</th>
              <th className="px-4 py-2 text-center">Actions</th>
            </tr>
          </thead>
          <tbody>
            {blogs.map((blog) => (
              <tr key={blog.id} className="border-t">
                <td className="px-4 py-2">{blog.title}</td>
                <td className="px-4 py-2 text-center">{blog.author}</td>
                <td className="px-4 py-2 text-center">{blog.date}</td>
                <td className="px-4 py-2 text-center">
                  <button
                    onClick={() => openForm(blog)}
                    className="px-3 py-1 text-sm bg-yellow-500 text-white rounded mr-2"
                  >
                    Edit
                  </button>
                  <button
                    onClick={() => deleteBlog(blog.id)}
                    className="px-3 py-1 text-sm bg-red-500 text-white rounded"
                  >
                    Delete
                  </button>
                </td>
              </tr>
            ))}

            {blogs.length === 0 && (
              <tr>
                <td colSpan="4" className="text-center py-4 text-gray-500">
                  No blogs found.
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      {/* ✅ ADD/EDIT BLOG FORM */}
      {showForm && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white p-6 rounded shadow-lg w-full max-w-lg relative">
            <h3 className="text-xl font-bold mb-4">
              {formData.id ? "Edit Blog" : "Add Blog"}
            </h3>

            <label className="block mb-2 font-semibold">Title</label>
            <input
              className="w-full p-2 border rounded mb-4"
              value={formData.title}
              onChange={(e) => setFormData({ ...formData, title: e.target.value })}
            />

            <label className="block mb-2 font-semibold">Author</label>
            <input
              className="w-full p-2 border rounded mb-4"
              value={formData.author}
              onChange={(e) => setFormData({ ...formData, author: e.target.value })}
            />

            <label className="block mb-2 font-semibold">Content</label>
            <textarea
              className="w-full p-2 border rounded mb-4 h-32"
              value={formData.content}
              onChange={(e) => setFormData({ ...formData, content: e.target.value })}
            ></textarea>

            <div className="flex justify-end gap-3">
              <button
                onClick={() => setShowForm(false)}
                className="px-4 py-2 bg-gray-300 rounded hover:bg-gray-400"
              >
                Cancel
              </button>
              <button
                onClick={saveBlog}
                className="px-4 py-2 bg-green-600 text-white rounded hover:bg-green-700"
              >
                Save
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
